import { render, staticRenderFns } from "./packageStockList.vue?vue&type=template&id=8a00d8b0"
import script from "./packageStockList.vue?vue&type=script&lang=js"
export * from "./packageStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports